import axios from "axios";

const endPoint = process.env.REACT_APP_API_ENDPOINT;

const endPoint2 = process.env.REACT_APP_API_SAP;

const courseEndPoint = process.env.REACT_APP_API_COURSE_FILTER;

export const countryApi = async (data) => {
  const respose = await axios.get(`${endPoint2}get-all-countries`, data);
  return respose;
};

export const stateApi = async (data) => {
  const respose = await axios.post(`${endPoint2}get-states-for-country`, data);
  return respose;
};

export const cityApi = async (data) => {
  const respose = await axios.post(`${endPoint2}get-city-for-states`, data);
  return respose;
};

export const broadFieldApi = async (data) => {
  const respose = await axios.get(`${endPoint2}get-broad-fields`, data);
  return respose;
};

export const narrowFieldApi = async (data) => {
  const respose = await axios.post(`${endPoint2}get-narrow-fields`, data);
  return respose;
};

export const fetchCoursesApi = async (data) => {
  const respose = await axios.get(`${endPoint}gradlynk-course-levels`, data);
  return respose;
};

export const fetchIntakesApi = async (data) => {
  const respose = await axios.get(`${endPoint}intakes`, data);
  return respose;
};

export const fetchEnglishTestsApi = async (data) => {
  const respose = await axios.get(
    `${endPoint}english-tests/get-all-tests`,
    data
  );
  return respose;
};

export const filterCoursesApi = async ({ url, payload }) => {
  return axios.post(url, payload);
};
